import { Heading } from '@chakra-ui/react';

type SectionHeaderProps = {
    children: React.ReactNode;
};

export function SectionHeader({ children }: SectionHeaderProps) {
    return (
        <Heading size="lg" fontWeight="400">
            {children}
        </Heading>
    );
}
